module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "product-item",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.showPromoteMessage) ? _c('promote-modal', {
    attrs: {
      "item": _vm.product,
      "dismiss": _vm.dismissPromoteModal,
      "success": _vm.saveAndFinish
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": "",
      "product-content-section": "",
      "pa-0": "",
      "relative": ""
    }
  }, [_c('div', {
    staticClass: "product-image",
    style: ({
      'background-image': 'url(' + _vm.product.covers[0].cover.thumb.url + ')',
    })
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "product-content",
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "product-content-row d-flex flex-column gap-4",
    attrs: {
      "xs12": "",
      "sm6": "",
      "pr-0": ""
    }
  }, [_c('label', {
    staticClass: "text-poppins-15"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('div', [(_vm.status && _vm.status != '') ? _c('label', {
    staticClass: "product-category-text"
  }, [_vm._v("\n              " + _vm._s(_vm.status) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "product-category-text"
  }, [_vm._v("\n              Category: " + _vm._s(_vm.product.category ? _vm.product.category.name : "") + "\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "product-count product-sold-count"
  }, [_vm._v("\n              Sold: " + _vm._s(_vm.product.sold) + "\n            ")]), _vm._v(" "), (_vm.product.stock_status == 'active') ? _c('label', {
    staticClass: "product-count product-status"
  }, [_vm._v("\n              " + _vm._s(_vm.product.stock_status) + "\n              "), _c('v-icon', {
    class: _vm.product.stock_status
  }, [_vm._v("done")])], 1) : _c('label', {
    staticClass: "product-count product-status"
  }, [_vm._v("\n              " + _vm._s(_vm.product.stock_status) + "\n              "), _c('v-icon', {
    class: _vm.product.stock_status
  }, [_vm._v("done")])], 1)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "product-content-row d-flex align-center justify-end gap-15",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.$store.state.auth.user.id == _vm.product.merchant.id) ? [_c('v-select', {
    staticClass: "pt-0 access-level",
    attrs: {
      "items": _vm.access_levels,
      "item-text": "title",
      "item-value": "id",
      "placeholder": "Select access level",
      "hide-details": "",
      "single-line": ""
    },
    on: {
      "change": function($event) {
        _vm.toggle_product_access_level_dialog = true
      }
    },
    model: {
      value: (_vm.access_level),
      callback: function($$v) {
        _vm.access_level = $$v
      },
      expression: "access_level"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "text-btn text-poppins-15",
    nativeOn: {
      "click": function($event) {
        _vm.editProduct()
      }
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-btn text-poppins-15",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.deleteItem(_vm.product)
      }
    }
  }, [_vm._v("Delete")])] : [(_vm.denyItem) ? _c('v-btn', {
    staticClass: "text-btn text-poppins-15",
    nativeOn: {
      "click": function($event) {
        _vm.denyItem(_vm.product)
      }
    }
  }, [_vm._v("Deny")]) : _vm._e(), _vm._v(" "), (_vm.denyItem) ? _c('label', {
    staticClass: "btn-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.acceptItem) ? _c('v-btn', {
    staticClass: "text-btn text-poppins-15",
    nativeOn: {
      "click": function($event) {
        _vm.acceptItem(_vm.product)
      }
    }
  }, [_vm._v("Accept")]) : _vm._e(), _vm._v(" "), (_vm.acceptItem) ? _c('label', {
    staticClass: "btn-divider"
  }) : _vm._e()]], 2)], 1)], 1), _vm._v(" "), (_vm.album.status == 'collaborated' || _vm.album.status == 'pending') ? _c('div', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (_vm.product.collaborators.length > 0) ? _c('v-flex', {
    attrs: {
      "sm12": "",
      "collaborator-content-section": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "text-poppins-14"
  }, [_vm._v("Collaborators (" + _vm._s(_vm.product.collaborators.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "collaborator-content"
  }, [_vm._l((_vm.product.collaborators), function(collaborator, i) {
    return _c('div', {
      key: i,
      staticClass: "collaborator-content__item"
    }, [_c('img', {
      staticClass: "collaborator-content__item--img",
      attrs: {
        "src": collaborator.user.avatar.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "collaborator-content__item__user"
    }, [_c('span', {
      staticClass: "username "
    }, [_vm._v("\n              " + _vm._s(collaborator.user.username) + "\n              "), (
      _vm.$store.state.auth.user.username === collaborator.user.username
    ) ? _c('span', [_vm._v("\n                (owner)\n              ")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "user-type"
    }, [_vm._v(_vm._s(collaborator.user.user_type))])])])
  }), _vm._v(" "), (_vm.product.status == 'pending') ? _c('div', [(_vm.currentUserOwnsProduct && _vm.allCollaboratedAccepted) ? _c('v-btn', {
    staticClass: "action-btn release",
    attrs: {
      "depressed": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.releaseButtonAction(_vm.product)
      }
    }
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("Release Now")])]) : _vm._e(), _vm._v(" "), (_vm.currentUserOwnsProduct && !_vm.allCollaboratedAccepted) ? _c('v-btn', {
    staticClass: "action-btn pending",
    attrs: {
      "depressed": "",
      "disabled": ""
    }
  }, [_c('span', [_vm._v("Pending")])]) : _vm._e(), _vm._v(" "), (_vm.isUserCollaborator) ? _c('div', {
    staticClass: "dflex collaborator-action"
  }, [_c('v-btn', {
    staticClass: "text-btn",
    attrs: {
      "disabled": _vm.allCollaboratedAccepted
    },
    nativeOn: {
      "click": function($event) {
        _vm.acceptCollaboration(_vm.product)
      }
    }
  }, [_vm._v("\n                Accept\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-btn",
    attrs: {
      "disabled": _vm.allCollaboratedAccepted
    },
    nativeOn: {
      "click": function($event) {
        _vm.denyCollaboration(_vm.product)
      }
    }
  }, [_vm._v("\n                Deny\n              ")])], 1) : _vm._e()], 1) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.toggle_product_access_level_dialog),
      callback: function($$v) {
        _vm.toggle_product_access_level_dialog = $$v
      },
      expression: "toggle_product_access_level_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Update Access Level\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to update the access level?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateAccessLevel()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e3e2eb3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/productitem.vue
// module id = 1797
// module chunks = 180